module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot6-1200x2490.788eb04e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot6-1200x2490.jpg
// module id = 1074
// module chunks = 37